"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.loyaltyReducer = exports.setSelectedLoyalty = void 0;
var toolkit_1 = require("@reduxjs/toolkit");
var constants_1 = require("../../../screens/console/pages/billing/loyalty/constants");
var initialState = {
    selectedLoyalty: constants_1.initialLoyaltyValues,
};
// only the loyalty form's draft lives here: the server record comes from loyaltyApi
var slice = (0, toolkit_1.createSlice)({
    name: "loyalty",
    initialState: initialState,
    reducers: {
        setSelectedLoyalty: function (state, action) {
            state.selectedLoyalty = action.payload;
        },
    },
});
var setSelectedLoyalty = slice.actions.setSelectedLoyalty;
exports.setSelectedLoyalty = setSelectedLoyalty;
var loyaltyReducer = slice.reducer;
exports.loyaltyReducer = loyaltyReducer;
